/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_DescriptionInputs */

const en_landing_drift_description = /** @type {(inputs: Landing_Drift_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real multi-pass sequence on one image: change the label, swap the cup, add a vase. Each pass edits only the painted area, and Pixel Lock copies every other pixel from the pass before.`)
};

const zh_landing_drift_description = /** @type {(inputs: Landing_Drift_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一张图上真实的连续编辑：改标签、换杯子、加花瓶。每一轮只编辑涂抹区域，像素锁定会把其余每个像素从上一轮原样拷回。`)
};

/**
* | output |
* | --- |
* | "A real multi-pass sequence on one image: change the label, swap the cup, add a vase. Each pass edits only the painted area, and Pixel Lock copies every other..." |
*
* @param {Landing_Drift_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_description = /** @type {((inputs?: Landing_Drift_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_description(inputs)
	return zh_landing_drift_description(inputs)
});
export { landing_drift_description as "landing.drift.description" }